import React, { useState } from 'react'
import Modal from '../common/Modal'
import SharedBusinessRulesTable from './SharedBusinessRulesTable'
import BusinessRule from '../../interfaces/BusinessRule'
import Column from '../../interfaces/Column'

type Props = {
  columns: Array<Column>,
  records: Array<BusinessRule>,
  ruleType: string,
  handleClose: () => void
}

const SharedBusinessRulesPriorityModal: React.FC<Props> = ({
  columns,
  records,
  ruleType,
  handleClose
}) => {
  const [close, setClose] = useState(false)

  const handleCancelButton = (event: React.SyntheticEvent) => {
    event.preventDefault()
    setClose(true)
    handleClose()
  }

  const businessRulesModal = () => {
    if (close) {
      return null
    }

    return (
      <Modal
        handleClose={handleCancelButton}
        className="priority-modal"
      >
        <h1>Business Rule Priority - {ruleType}</h1>
        <SharedBusinessRulesTable
          records={records}
          filtered={false}
          columns={columns}
        />
      </Modal>
    )
  }

  return (businessRulesModal())
}

export default SharedBusinessRulesPriorityModal
